import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

export default function MobileMenu() {

  const location = useLocation()

  if (location.pathname == '/') {
    return null;
  }


  return (
    <ul className='mobileMenu'>
      <li>
        {location.pathname.includes('/about') ?
          <span className='chosen'>About</span> :
          <Link to='/about'>About</Link>
        }
      </li>
      <li>
        {location.pathname.includes('/series/one') ?
          <span className='chosen'>Series 1</span> :
          <Link to='/series/one'>Series 1</Link>
        }
      </li>
      <li>
        {location.pathname.includes('/from-the-editors') ?
          <span className='chosen'>From the Editors</span> :
          <Link to='/from-the-editors'>Editors Notes</Link>
        }
      </li>
      <li>
        {location.pathname.includes('/contact') ?
          <span className='chosen'>Contact</span> :
          <Link to='/contact'>Contact</Link>
        }
      </li>
    </ul>
  )
}